import React, { Component } from 'react'
import axios from 'axios';

export class login extends Component {
    state={
        user:[]
    }
    componentWillMount(){
        axios({
            method: 'get',
            url: 'https://gameintourney.com/wp-json/wp/v2/users/'
        })
        .then(posts=>{
            console.log("get succeed =",posts);
            this.setState({
                    user:posts.data
            },()=>console.log("POSSTTTTT = ",this.state.user));
        })
        .catch(err=>{
            console.log("Error Get Data");
            console.log("ERROR = ",err);
        });
    }
    insertData=(e)=>{
        e.preventDefault();
        console.log("erere");
        const post = {"title":"SAYKOO","content":"Clarks","status":"publish"} ;
        console.log("POST = ",post);
        axios({
            method: 'post',
            url: 'https://gameintourney.com/wp-json/wp/v2/users/',
            data:post,
            headers: {
                'Content-Type' : 'application/json',
                'Authorization':'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwczpcL1wvZ2FtZWludG91cm5leS5jb20iLCJpYXQiOjE1NjI0MjYyOTIsIm5iZiI6MTU2MjQyNjI5MiwiZXhwIjoxNTYzMDMxMDkyLCJkYXRhIjp7InVzZXIiOnsiaWQiOiIxIn19fQ.1xbOQfVlBCqQtND_MG2Y2jQiSS1qZbo8jmA1zcCMFDw'
              },
        })
        .then(posts=>{
            console.log("posts =",posts)
            this.setState({
                user:[
                    posts.data,
                    ...this.state.user,
                ]
            },()=>{console.log("NEW UPDATED POSTS = ",this.state.user)})
        })
        .catch(err=>{
            console.log("Error Create Post");
            console.log("ERROR = ",err);
        });
    }
    containsObject(obj, list){
        var i;
        for (i = 0; i < list.length; i++) {
            if (list[i].id === obj) {
                console.log("TRUEE");
                return true;
            }
        }
        console.log("FALSEE");
        return false;
    }
    updateData=(e)=>{
        e.preventDefault();
        console.log("erere");
        const post = {"title":"MEMENTEII","content":"Clarks","status":"publish"} ;
        let idData=107;
        console.log("POST = ",post);
        if(this.containsObject(idData,this.state.user)){
            axios({
                method: 'put',
                url: 'https://gameintourney.com/wp-json/wp/v2/users/'+idData,
                data:post,
                headers: {
                    'Content-Type' : 'application/json',
                    'Authorization':'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwczpcL1wvZ2FtZWludG91cm5leS5jb20iLCJpYXQiOjE1NjI0MjYyOTIsIm5iZiI6MTU2MjQyNjI5MiwiZXhwIjoxNTYzMDMxMDkyLCJkYXRhIjp7InVzZXIiOnsiaWQiOiIxIn19fQ.1xbOQfVlBCqQtND_MG2Y2jQiSS1qZbo8jmA1zcCMFDw'
                  },
            })
            .then(posts=>{
                console.log("posts =",posts)
                console.log("HAS SAME USER = ",this.state.user.includes(idData)); 
                // this.setState({
                //     user:[
                //         posts.data,
                //         ...this.state.user,
                //     ]
                // },()=>{console.log("NEW UPDATED POSTS = ",this.state.user)})
                
            })
            .catch(err=>{
                console.log("Error Create Post");
                console.log("ERROR = ",err);
            });
        }

    }
    deleteData=(e)=>{
        e.preventDefault();
        console.log("erere");
        const post = {"title":"MEMENTEII","content":"Clarks","status":"publish"} ;
        let idData=108;
        console.log("POST = ",post);
        if(this.containsObject(idData,this.state.user)){
            axios({
                method: 'delete',
                url: 'https://gameintourney.com/wp-json/wp/v2/users/'+idData,
                data:post,
                headers: {
                    'Content-Type' : 'application/json',
                    'Authorization':'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwczpcL1wvZ2FtZWludG91cm5leS5jb20iLCJpYXQiOjE1NjI0MjYyOTIsIm5iZiI6MTU2MjQyNjI5MiwiZXhwIjoxNTYzMDMxMDkyLCJkYXRhIjp7InVzZXIiOnsiaWQiOiIxIn19fQ.1xbOQfVlBCqQtND_MG2Y2jQiSS1qZbo8jmA1zcCMFDw'
                  },
            })
            .then(posts=>{
                console.log("posts =",posts)
                console.log("HAS SAME USER = ",this.state.user.includes(idData)); 
                // this.setState({
                //     user:[
                //         posts.data,
                //         ...this.state.user,
                //     ]
                // },()=>{console.log("NEW UPDATED POSTS = ",this.state.user)})
                
            })
            .catch(err=>{
                console.log("Error Create Post");
                console.log("ERROR = ",err);
            });
        }

    }
    render() {
        const {user} = this.state;
        return (
            <div>
                {
                    user.map( (item,idx)=>
                        <div key={item.id}>
                            <p>User {idx} = {item.title.rendered}</p>
                            <p>ID = {item.id}</p><br/><br/>
                        </div>
                    )
                }
                <form onSubmit={this.insertData}>
                    <input type="text" id="login" className="fadeIn second" name="login" placeholder="login"/>
                    <input type="text" id="password" className="fadeIn third" name="login" placeholder="password"/>
                    <input type="submit" className="fadeIn fourth" value="Log In"/>
                    
                </form><br/>
                <form onSubmit={this.updateData}>
                    <input type="submit" className="fadeIn fourth" value="Update"/>
                </form><br/>
                <form onSubmit={this.deleteData}>
                    <input type="submit" className="fadeIn fourth" value="Delete"/>
                </form>
            </div>
        )
    }
}

export default login
